/**
 * NewsClimatic — Página independiente de búsqueda de noticias sobre
 * fenómenos climáticos. Accesible desde el menú lateral. Cuando se accede
 * dentro de un expediente, se usa el panel con `expedienteId` precargado
 * para que el PDF se adjunte automáticamente como evidencia.
 */
import NewsClimaticPanel from "@/components/news_climatic/NewsClimaticPanel";
import { Newspaper } from "@phosphor-icons/react";

export default function NewsClimatic() {
  return (
    <div className="max-w-6xl mx-auto px-4 md:px-6 py-5 md:py-6 space-y-5"
         data-testid="news-climatic-page">
      <header className="flex items-center gap-3">
        <span className="icon-chip icon-chip-brand">
          <Newspaper className="w-4 h-4" weight="regular" />
        </span>
        <div className="flex-1">
          <h1 className="page-title">Noticias climáticas</h1>
          <p className="help-text">
            Busca noticias sobre fenómenos climáticos o atmosféricos por
            provincia y rango de fechas. Fuente: Google News. El PDF generado
            queda como evidencia documental del expediente.
          </p>
        </div>
      </header>
      <NewsClimaticPanel />
    </div>
  );
}
